import { createI18n } from 'vue-i18n'
import { DEFAULT_LANGUAGE, FALLBACK_LANGUAGE } from '@/constants/trans'
import sv from '@/lang/sv.json'

// legacy: true keeps the Options-API surface ($t, this.$i18n) used app-wide.
export const i18n = createI18n({
    legacy: true,
    locale: DEFAULT_LANGUAGE,
    fallbackLocale: FALLBACK_LANGUAGE,
    messages: { sv },
})
